<h3 *ngIf="title" class="mt-0">{{ title }}</h3>
<app-link 
 *ngFor="let docIindex of indexes; let i = index"
 (click)="setActive(i)" 
 [ngClass]="{ '-active': docIindex.active }"
 [to]="docIindex.path">
 {{ docIindex.title }}
</app-link>